import { isNumber } from 'lodash/fp';

export default (input = 0) => (
  isNumber(input)
    ? input + 1
    : input
);
